<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="60%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="图片" prop="image">
          <el-upload
            :multiple="false"
            :limit="1"
            :class="{ disabled: form.image.length > 0 }"
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.image"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸{{ form.mode === 'large' ? '355px * 120px' : '173px * 74px'}}</span>
        </el-form-item>
        <el-form-item label="大小" prop="mode">
          <el-radio v-for="(item,index) of modeList" :key="index" v-model="form.mode" :label="item.type">{{item.value}}</el-radio>
        </el-form-item>
        <el-form-item label="跳转页面地址" prop="url">
          <el-input v-model.trim="form.url" placeholder="请输入跳转页面地址" />
        </el-form-item>
        <el-form-item label="位置" prop="position">
          <el-select
            v-model="form.position"
            placeholder="请选择位置"
          >
            <el-option
              v-for="item in positionList"
              :key="item.type"
              :label="item.value"
              :value="item.type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createBanner, updateBanner } from '@/api/display'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
import { positionList,modeList } from '@/utils/const'
export default {
  name: 'BannerEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      uploadToken: '',
      positionList,
      modeList,
      form: {
        bannerId: '',
        image: [],
        mode: '',
        url: '',
        position: '',
        order: 1,
      },
      rules: {
        position: [{ required: true, trigger: 'blur', message: '请输入位置' }],
        mode: [{ required: true, trigger: 'blur', message: '请选择大小' }],
        image: [
          {
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传图片'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改横幅'
        this.form = Object.assign(this.form, row.basic)
        this.form.bannerId = row.bannerId
      } else {
        this.title = '新增横幅'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    // 图片
    image_remove(file, fileList) {
      this.form.image = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.image.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const bannerId = this.form.bannerId
          this.$baseConfirm(
            `你确定要${bannerId ? '修改' : '新增'}横幅吗`,
            null,
            async () => {
              bannerId
                ? await updateBanner(this.form)
                : await createBanner(this.form)
              this.$baseMessage(
                `${bannerId ? '修改' : '新增'}横幅成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss">
.disabled .el-upload--picture-card {
  display: none;
}
</style>
